import React from 'react'
import '../../css/components/controls/HrnbLabel.css'

export default function HrnbLabel({
    children,
    text,
    className = "",
    required = false,
    disabled = false,
    hint = "",
    error = "",
    icon = null,
    ...props
}) {
    return (
        <div className={`hrnb-label-wrap ${className} ${disabled ? "hrnb-label--disabled" : ""}`}>
            <label className="hrnb-label" {...props}>
                {icon && <span className="hrnb-label__icon">{icon}</span>}
                {text}
                {required && <span className="hrnb-label__required">*</span>}
            </label>
            {children}
            {error
                ? <div className="hrnb-label__error">{error}</div>
                : hint && <div className="hrnb-label__hint">{hint}</div>
            }
        </div>
    );
}